/** Auto-aligned with Order_summary status100 shell; targets #invoice-pdf for print. */
export const INVOICE_STATUS100_SHELL_STYLES = `
        .status100-shell * { box-sizing: border-box; }
        .status100-shell {
          width: 100%;
          max-width: 940px;
          margin: 0 auto;
          background: #ffffff;
          border: 1px solid #d4dae4;
          border-radius: 18px;
          overflow: visible;
          box-shadow: 0 12px 34px rgba(15, 23, 42, 0.12);
          color: #111827;
          letter-spacing: 0.012em;
        }
        // .status100-pad { padding: 28px 32px; }
        .status100-pad { padding: 14px 32px 0px 32px; }
        .status100-padcustom { padding: 3px 32px; }
        /* Title + logo + meta (aligned with Order_summary hero) */
        .status100-hero {
          display: grid;
          grid-template-columns: auto 1fr auto;
          grid-template-rows: auto auto;
          column-gap: 20px;
          row-gap: 10px;
          align-items: start;
          position: relative;
        }
        .status100-hero-title-wrap {
          grid-column: 1 / -1;
          justify-self: center;
          text-align: center;
          width: 100%;
        }
        .status100-hero .status100-brand {
          grid-column: 1;
          grid-row: 2;
          justify-self: start;
          align-self: center;
          width: auto;
          min-width: 0;
          min-height: 0;
          display: block;
          overflow: visible;
        }
        .status100-hero .status100-brand img {
          width: auto;
          max-width: 220px;
          height: auto;
          max-height: 60px;
          object-fit: contain;
          object-position: left center;
          display: block;
        }
        .status100-hero .status100-header-right {
          grid-column: 3;
          grid-row: 2;
          justify-self: end;
        }
        .status100-brand-name {
          font-size: 28px;
          font-weight: 700;
          letter-spacing: 0.005em;
        }
        .status100-header-right {
          min-width: 320px;
          max-width: 52%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 10px;
        }
        .status100-title {
          font-size: 22px;
          font-weight: 700;
          line-height: 1.1;
        }
        .status100-meta-grid {
          display: grid;
          grid-template-columns: max-content max-content;
          column-gap: 16px;
          row-gap: 10px;
          align-items: baseline;
          justify-content: end;
          width: max-content;
          max-width: 100%;
          margin-left: auto;
        }
        .status100-meta-grid .status100-meta-label {
          text-transform: none;
          letter-spacing: normal;
          justify-self: start;
          white-space: nowrap;
        }
        .status100-meta-grid .status100-meta-value {
          font-size: 13px;
          font-weight: 500;
          color: #111827;
          text-align: right;
          justify-self: end;
          min-width: 0;
          white-space: nowrap;
        }
        .status100-meta-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .status100-meta-label {
            font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;font-weight: 500;
          // text-transform: uppercase;
          letter-spacing: 0.05em;
        }
        .status100-meta-value {
          font-size: 13px;
          font-weight: 500;
          color: #111827;
        }
        .status100-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 7px 14px;
          border-radius: 8px;
          background: #00a63e !important;
          color: #ffffff;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: normal;
          white-space: nowrap;
          line-height: 1.25;
          max-width: max-content;
        }
        .status100-section { margin-top: 26px; }
        .status100-section-head {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 14px;
        }
        .status100-card {
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          background: #fafbfd;
        }
        .status100-customer-box {
          padding: 20px;
        }
        .status100-customer-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 16px 22px;
        }
        .status100-customer-grid > div {
          min-width: 0;
        }
        .status100-email-cell {
          min-width: 0;
          max-width: 100%;
        }
        .status100-address-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;
        }
        .status100-address-card {
          position: relative;
          padding: 18px 18px 18px 20px;
          min-height: 150px;
          overflow: hidden;
        }
        .status100-address-card::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 3px;
          height: 100%;
          // background: rgba(59, 111, 232, 0.32);
        }
        .status100-address-label {
          margin-bottom: 10px;
          font-size: 0.875rem;
          color: #111827;
          letter-spacing: 0.01em;
          font-family: Roboto, sans-serif;
          font-weight: 500 !important;
        }
        .status100-address-line {
          line-height: 1.75;
          font-size: 0.875rem;
          color: #111827;
          letter-spacing: 0.01em;
          font-family: Roboto, sans-serif;
        }

        .status100-address-line.is-name {
          font-weight: 700;
          color: #111827;
        }
        .status100-table-wrap {
          overflow-x: auto;
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          background: #ffffff;
        }
        .status100-table {
          width: 100%;
          min-width: 860px;
          border-collapse: collapse;
        }
        .status100-table thead tr { background: #f5f7fb; }
        .status100-table th {
          padding: 12px 14px;
          text-align: left;
          font-weight: 700;
          border-bottom: 1px solid #e5e7eb;
          font-size: 0.875rem;
          line-height: 1.75;
          color: #111827;
          letter-spacing: 0.01em;
          font-family: Roboto, sans-serif;
        }
        .status100-table tbody tr {
          break-inside: avoid;
          page-break-inside: avoid;
        }
        .status100-table td {
          padding: 16px 14px;
          border-bottom: 1px solid #f0f2f5;
          vertical-align: top;
          font-size: 14px;
          color: #374151;
        }
        .status100-table tbody tr:last-child td { border-bottom: none; }
        .status100-right { text-align: right;
        //  color : #4b5563;
             font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
    font-weight: 500;
          }
        .status100-qty { text-align: center; color : #4b5563; }
        .status100-product-cell {
          display: flex;
          gap: 14px;
          align-items: flex-start;
        }
        .status100-thumb {
          width: 80px;
          height: 80px;
          max-width: 100%;
          border-radius: 8px;
          // border: 1px solid #e5e7eb;
          // background: #f9fafb;
          object-fit: contain;
          flex-shrink: 0;
          box-sizing: border-box;
        }
        .status100-thumb-fallback {
          width: 52px;
          height: 52px;
          max-width: 100%;
          box-sizing: border-box;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          background: #f9fafb;
          color: #9ca3af;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: 600;
          line-height: 1.2;
          text-align: center;
          padding: 4px;
          flex-shrink: 0;
          word-break: break-word;
        }
        .status100-product-name {
          font-size: 15px;
          font-weight: 700;
          color: #495363 !important;
          line-height: 1.4;
          letter-spacing: 0.01em;
        }
        .status100-product-sku {
          // font-size: 12px;
          // color: #495363 !important;
          margin-top: 4px;
          // letter-spacing: 0.01em;

              font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
    font-weight: 500;
        }
        .status100-product-detail {
             font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
          line-height: 1.6;
          // letter-spacing: 0.01em;
        }
        .status100-total-bold {
          font-weight: 700;
          color: #111827;
        }
        /* Flex row: notes | totals (more reliable than grid for narrow + wide layouts) */
        .status100-shell .status100-bottom {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: nowrap !important;
          align-items: flex-start;
          justify-content: space-between;
          gap: clamp(12px, 2.5vw, 26px);
          width: 100%;
          box-sizing: border-box;
          margin-top: 24px;
          break-inside: avoid;
          page-break-inside: avoid;
        }
        .status100-bottom > div:first-child {
          flex: 1 1 0%;
          min-width: max(200px, min(360px, calc(100% - 318px)));
          max-width: min(360px, calc(100% - 318px));
        }
        .status100-bottom > .status100-payment-card {
          flex: 0 0 290px;
          flex-shrink: 0;
          width: 290px;
          min-width: 148px;
          max-width: 290px;
          box-sizing: border-box;
          margin-left: auto;
        }
        .status100-notes-box {
          background: #ffffff;
          padding: 18px;
          min-height: 84px;
          width: 100%;
          max-width: none;
          box-sizing: border-box;
          word-break: normal;
          overflow-wrap: break-word;
          box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
        }
        .status100-payment-card {
          background: #ffffff;
          border: 1px solid #dde3ed;
          border-radius: 10px;
          padding: 22px;
          box-shadow: 0 8px 28px rgba(15, 23, 42, 0.10);
          max-width: 100%;
          box-sizing: border-box;
        }
        .status100-total-heading {
          font-weight: 700;
          padding-bottom: 12px;
          border-bottom: 1px solid #edf0f4;
          margin-bottom: 2px;

          font-size: 0.975rem;
    color: rgb(17, 24, 39);
    letter-spacing: 0.01em;
    font-family: Roboto, sans-serif;
    font-weight: 700;
        }
        .status100-total-line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          padding: 10px 0;
          border-bottom: 1px solid #edf0f4;
          // font-size: 14px;
          // color: #4b5563;
          font-weight: 500;

              font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
        }
        .status100-grand {
          margin-top: 14px;
          padding: 14px 16px;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          background: #f8faff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
        }
        .status100-grand-label {
          font-size: 14px;
          font-weight: 700;
          color: #111827;
        }
        .status100-grand-value {
          font-size: 18px;
          font-weight: 700;
          color: #3b6fe8;
        }
        .status100-bottom-pay-block {
          margin-top: 4px;
        }
        .status100-bottom-pay-block .status100-pay-btn {
          border: none;
          cursor: pointer;
        }
        .status100-pay-btn {
          display: block;
          width: 100%;
          margin-top: 14px;
          text-align: center;
          text-decoration: none;
          border-radius: 10px;
          padding: 14px 18px;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          color: #ffffff;
          font-size: 15px;
          font-weight: 700;
          box-shadow: 0 6px 18px rgba(34, 197, 94, 0.22);
        }
        .status100-pay-note,
        .status100-contact-note {
          text-align: center;
              font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
    font-weight: 500;
          margin-top: 12px;
          line-height: 1.5;
        }
        .status100-contact-note a,
        .status100-email-link,
        .status100-footer-link {
          color: #3b6fe8;
          text-decoration: none;
          overflow-wrap: anywhere;
          word-break: break-word;
          max-width: 100%;
        }
        .status100-contact-note a:hover,
        .status100-email-link:hover,
        .status100-footer-link:hover {
          text-decoration: none;
          color: #2563eb;
        }
        .status100-powered-lead {
              font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
        }
        .status100-powered-brand {
          color: #2563eb;
          font-weight: 600;
          text-decoration: none;
        }
        .status100-powered-brand:hover {
          text-decoration: none;
          color: #2563eb;
        }
        .status100-footer {
          margin-top: 28px;
          border-top: 1px solid #e5e7eb;
          background: #fafbfd;
          padding: 24px 32px 26px;
        }
        .status100-footer-contact {
          text-align: center;
          font-size: 13px;
          color: #4b5563;
          line-height: 1.8;
        }
        .status100-footer-divider {
          margin: 0 12px;
          color: #c4c9d4;
        }
        .status100-terms {
          margin-top: 18px;
          border-top: 1px solid #e5e7eb;
          padding-top: 18px;
        }
        .status100-terms-label {
          margin-bottom: 8px;

           font-size: 0.975rem;
    color: rgb(17, 24, 39);
    letter-spacing: 0.01em;
    font-family: Roboto, sans-serif;
    font-weight: 700;
        }
        .status100-terms-text {
             font-size: 0.875rem;
    color: #111827;
    letter-spacing: -.025em;
    font-family: Roboto, sans-serif;
    font-weight: 500;
          line-height: 1.7;
        }
        .status100-powered {
          text-align: center;
          margin-top: 16px;
          font-size: 12px;
          font-weight: 500;
        }
        @media screen and (max-width: 900px) {
          /* Mobile: match Order_summary — title top center, smaller logo left, meta + badge right; section alignments */
          #invoice-pdf .status100-hero.status100-pad {
            padding-bottom: 20px;
            border-bottom: 1px solid #e5e7eb;
          }
          #invoice-pdf .status100-padcustom {
            padding: 20px 32px 3px;
          }
          #invoice-pdf .status100-padcustom > .status100-section:first-child {
            margin-top: 0;
          }
          #invoice-pdf .invoice-title-row {
            white-space: normal;
          }
          .status100-hero {
            grid-template-columns: minmax(0, 1fr);
            grid-template-rows: auto auto auto;
            column-gap: 0;
            row-gap: 10px;
          }
          .status100-hero-title-wrap {
            grid-column: 1;
            grid-row: 1;
            justify-self: center;
            text-align: center;
            width: 100%;
            max-width: 100%;
          }
          .status100-hero .status100-brand {
            grid-column: 1;
            grid-row: 2;
            justify-self: start;
            align-self: start;
            width: auto;
            display: block;
            text-align: left;
          }
          .status100-hero .status100-brand img {
            margin-left: 0;
            margin-right: 0;
            max-width: 150px;
            max-height: 48px;
          }
          .status100-hero .status100-brand-name {
            font-size: 20px;
            line-height: 1.15;
          }
          .status100-hero .status100-header-right {
            grid-column: 1;
            grid-row: 3;
            justify-self: end;
            width: 100%;
            min-width: 0;
            max-width: 100%;
            align-items: flex-end;
            text-align: right;
          }
          .status100-title {
            width: 100%;
            text-align: center;
          }
          #invoice-pdf .status100-hero .status100-title {
            font-size: 18px;
            line-height: 1.2;
          }
          .status100-meta-grid {
            margin-left: auto;
            margin-right: 0;
            width: max-content;
            max-width: 100%;
            justify-items: unset;
          }
          .status100-meta-grid .status100-meta-label {
            text-align: left;
          }
          .status100-meta-grid .status100-meta-value {
            text-align: right;
          }
          .status100-badge {
            align-self: flex-end;
          }
          .status100-section-head {
            justify-content: flex-start;
          }
          .status100-customer-grid,
          .status100-address-grid {
            grid-template-columns: 1fr;
          }
          .status100-customer-grid > div {
            text-align: center;
          }
          .status100-section--customer .status100-customer-grid > div {
            text-align: left;
          }
          .status100-section--delivery .status100-address-card,
          .status100-section--delivery .status100-address-label,
          .status100-section--delivery .status100-address-line {
            text-align: left;
          }
        }
        @media screen and (max-width: 640px) {
          .status100-pad,
          .status100-footer {
            padding: 20px 16px;
          }
          #invoice-pdf .status100-padcustom {
            padding: 20px 16px 3px;
          }
          #invoice-pdf .status100-hero .status100-title {
            font-size: 16px;
            line-height: 1.2;
          }
          #invoice-pdf .status100-hero .status100-brand img {
            max-width: 120px;
            max-height: 40px;
          }
          #invoice-pdf .status100-hero .status100-brand-name {
            font-size: 18px;
          }
          .status100-footer-contact { text-align: left; }
          .status100-footer-divider { display: none; }
          .status100-footer-contact-line { display: block; margin-bottom: 4px; }
        }

        /* ≤1021px: SignageOrders-style line-item cards; stack notes + totals (matches .rdt-mobile breakpoint) */
        @media screen and (max-width: 1021px) {
          .status100-shell .status100-bottom {
            flex-direction: column !important;
            flex-wrap: nowrap !important;
            align-items: stretch !important;
            gap: 16px !important;
          }
          .status100-shell .status100-bottom > div:first-child {
            min-width: 0 !important;
            max-width: 100% !important;
            width: 100% !important;
          }
          .status100-shell .status100-bottom > .status100-payment-card {
            flex: 0 0 auto !important;
            width: 100% !important;
            max-width: 100% !important;
            margin-left: 0 !important;
          }
          /* Invoice bottom: notes + payment cards padding matches address cards (Order_summary) */
          #invoice-pdf .status100-notes-box,
          #invoice-pdf .invoice-notes-box-full {
            padding: 18px 18px 18px 20px !important;
            min-height: 0 !important;
            box-shadow: none !important;
          }
          #invoice-pdf .invoice-payment-totals-row .status100-payment-card {
            padding: 18px 18px 18px 20px !important;
            box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06) !important;
          }
        }

        .status100-mobile-items {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .status100-mobile-item-head {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }
        .status100-mobile-item-head-main {
          flex: 1 1 0%;
          min-width: 0;
        }
        .status100-mobile-item-fields {
          margin-top: 12px;
        }
        #invoice-pdf .rdt-mobile .status100-mobile-item-head > div:first-child {
          flex-shrink: 0;
          min-width: 80px;
        }
        #invoice-pdf .rdt-mobile .status100-mobile-item-head img.status100-thumb {
          max-width: none;
          width: 80px;
          height: 80px;
        }
        /* Sales mobile cards: same as Order_summary — numeric rows label / value */
        #invoice-pdf .rdt-mobile .status100-mobile-item-fields > .po-field:not(:first-child) {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: baseline;
          gap: 10px;
          padding: 8px 0;
        }
        #invoice-pdf .rdt-mobile .status100-mobile-item-fields > .po-field:not(:first-child) .po-field-label {
          margin-bottom: 0;
        }
        #invoice-pdf .rdt-mobile .status100-mobile-item-fields > .po-field:not(:first-child) .po-field-value {
          text-align: right;
          font-weight: 500;
        }
        #invoice-pdf .rdt-mobile .status100-mobile-item-fields > .po-field:not(:first-child) .po-field-value.status100-total-bold {
          font-weight: 600;
        }
        /* Job line mobile cards: .po-field directly under .po-card */
        #invoice-pdf .rdt-mobile .po-card > .po-field {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: baseline;
          gap: 10px;
          padding: 8px 0;
        }
        #invoice-pdf .rdt-mobile .po-card > .po-field .po-field-label {
          margin-bottom: 0;
        }
        #invoice-pdf .rdt-mobile .po-card > .po-field .po-field-value {
          text-align: right;
          font-weight: 500;
        }

        /* Screen: printable root (InvoiceDocument-style wrapper) */
        .invoice-print-inner {
          width: 100%;
          max-width: 940px;
          margin: 0 auto;
        }

        /*
         * Paged margin + page numbers (same idea as InvoiceDocument SCREEN_STYLES).
         * Chrome may ignore @bottom-right; margin still controls printable area.
         * To remove URL/title/date from paper: in the print dialog, turn OFF "Headers and footers".
         */
        @page {
          size: A4 portrait;
          margin: 10mm 10mm 16mm 10mm;
          @bottom-right {
            content: counter(page) " of " counter(pages);
            font-size: 11px;
            color: #64748b;
          }
        }

        /* ========== Print: Invoice-style — only #invoice-pdf, less blank gaps ========== */
        @media print {
          html,
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
            background: #fff !important;
          }
          /* Print only the order summary (hide app chrome), same pattern as #invoice-pdf */
          body * {
            visibility: hidden !important;
          }
          #invoice-pdf,
          #invoice-pdf * {
            visibility: visible !important;
          }
          #invoice-pdf .rdt-mobile {
            display: none !important;
          }
          #invoice-pdf .rdt-desktop {
            display: block !important;
          }
          .no-print,
          .d-print-none {
            display: none !important;
          }
          .invoice-print-root {
            padding: 0 !important;
            margin: 0 !important;
            background: #fff !important;
            max-width: none !important;
          }
          #invoice-pdf {
            position: absolute !important;
            left: 0 !important;
            top: 0 !important;
            width: 794px !important;
            max-width: 794px !important;
            margin: 0 auto !important;
          }
          #invoice-pdf .status100-shell {
            max-width: 100% !important;
            width: 100% !important;
            margin: 0 auto !important;
            box-shadow: none !important;
            border: 1px solid #d4dae4 !important;
            border-radius: 12px !important;
            overflow: visible !important;
            background: #fff !important;
          }
          // .status100-pad {
          //   padding: 22px 26px !important;
          // }
          .status100-footer {
            padding: 20px 26px 22px !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          /* Override responsive breakpoints: desktop hero grid when printing */
          #invoice-pdf .status100-hero {
            display: grid !important;
            grid-template-columns: auto 1fr auto !important;
            grid-template-rows: auto auto !important;
            column-gap: 20px !important;
            row-gap: 10px !important;
            align-items: start !important;
          }
          #invoice-pdf .status100-hero-title-wrap {
            grid-column: 1 / -1 !important;
            justify-self: center !important;
            text-align: center !important;
            width: 100% !important;
          }
          #invoice-pdf .status100-hero .status100-brand {
            grid-column: 1 !important;
            grid-row: 2 !important;
            justify-self: start !important;
            align-self: center !important;
            display: block !important;
            width: 220px !important;
            min-width: 220px !important;
            min-height: 60px !important;
            text-align: left !important;
            overflow: hidden !important;
          }
          #invoice-pdf .status100-hero .status100-brand img {
            width: 220px !important;
            height: 60px !important;
            object-fit: contain !important;
            object-position: left center !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
          }
          .status100-header-right {
            width: auto !important;
            min-width: 220px !important;
            max-width: 50% !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-end !important;
            align-self: flex-start !important;
          }
          #invoice-pdf .status100-hero .status100-header-right {
            grid-column: 3 !important;
            grid-row: 2 !important;
            justify-self: end !important;
            flex: 0 1 auto !important;
            margin-left: auto !important;
            align-items: flex-end !important;
            text-align: right !important;
          }
          .status100-meta-grid {
            width: max-content !important;
            max-width: 100% !important;
            margin-left: auto !important;
            margin-right: 0 !important;
            justify-content: end !important;
          }
          #invoice-pdf .status100-meta-grid {
            display: grid !important;
            grid-template-columns: auto auto !important;
            margin-left: auto !important;
            margin-right: 0 !important;
            justify-content: end !important;
          }
          #invoice-pdf .status100-badge {
            align-self: flex-end !important;
            letter-spacing: normal !important;
            white-space: nowrap !important;
            line-height: 1.25 !important;
            max-width: max-content !important;
          }
          #invoice-pdf .invoice-title-row {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
            text-align: center !important;
          }
          #invoice-pdf .invoice-title-row .status100-title {
            text-align: center !important;
            width: 100% !important;
          }
          #invoice-pdf .status100-meta-grid .status100-meta-label {
            text-align: left !important;
            justify-self: start !important;
          }
          #invoice-pdf .status100-meta-grid .status100-meta-value {
            text-align: right !important;
            justify-self: end !important;
          }
          #invoice-pdf .status100-section-head {
            justify-content: flex-start !important;
          }
          #invoice-pdf .status100-customer-grid > div {
            text-align: left !important;
          }
          #invoice-pdf .status100-address-card,
          #invoice-pdf .status100-address-label,
          #invoice-pdf .status100-address-line {
            text-align: left !important;
          }
          .status100-customer-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            gap: 14px 18px !important;
          }
          .status100-address-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            gap: 14px !important;
          }
          .status100-table-wrap {
            overflow: visible !important;
          }
          .status100-table {
            min-width: 0 !important;
            width: 100% !important;
            border-collapse: collapse !important;
          }
          .status100-table thead tr {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          /* Keep each row/card together; move whole block to next page if needed */
          .status100-table {
            break-inside: auto !important;
            page-break-inside: auto !important;
          }
          .status100-table tbody tr,
          .status100-table tbody td,
          .status100-section,
          .status100-section-head,
          .status100-card {
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }
          .status100-table thead {
            display: table-header-group !important;
          }
          .status100-table tfoot {
            display: table-footer-group !important;
          }
          /* Only keep small blocks from splitting awkwardly */
          .status100-address-card,
          .status100-customer-box .status100-card {
            break-inside: avoid;
            page-break-inside: avoid;
          }
          .status100-notes-box {
            break-inside: avoid;
            page-break-inside: avoid;
          }
          .status100-bottom {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: clamp(12px, 2vw, 20px) !important;
            width: 100% !important;
            break-inside: avoid !important;
            page-break-inside: avoid !important;
          }
          .status100-bottom > div:first-child {
            flex: 1 1 0% !important;
            min-width: 0 !important;
            max-width: min(360px, calc(100% - 300px)) !important;
          }
          .status100-bottom > .status100-payment-card {
            flex: 0 0 290px !important;
            margin-left: auto !important;
            max-width: 290px !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .status100-grand {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .status100-badge {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            align-self: flex-end !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
            letter-spacing: normal !important;
            white-space: nowrap !important;
            line-height: 1.25 !important;
          }
          .status100-pay-btn,
          .status100-pay-note {
            display: none !important;
          }
          img,
          .status100-thumb {
            max-width: 100% !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .status100-email-link,
          .status100-footer-link {
            overflow-wrap: anywhere !important;
            word-break: break-word !important;
            max-width: 100% !important;
          }
          .status100-email-cell {
            min-width: 0 !important;
            max-width: 100% !important;
          }
          /* Hide placeholder footer div if added; page numbers use @page when supported */
          .print-page-footer {
            display: none !important;
          }
        }
      `;
